/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"CSelect":"CSelect_d4IiS","disabled":"disabled_rTR6I","label":"label_TNXy-"};